import {API_URL, handleErrorResponse} from "../utility/utility";

export async function findItemCategories(signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/item-categories`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch item categories');

    return response.json();
}

export async function createItemCategory(parentId, name, order) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/item-categories`, {
        method  : 'POST',
        body    : JSON.stringify({
            parentId : parentId,
            name     : name,
            order    : order
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create item category');
}

export async function updateItemCategory(itemCategoryId, parentId, name, order) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/item-categories/${itemCategoryId}`, {
        method  : 'PATCH',
        body    : JSON.stringify({
            parentId : parentId,
            name     : name,
            order    : order
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to update item category');
}

export async function deleteItemCategory(itemCategoryId) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/item-categories/${itemCategoryId}`, {
        method  : 'DELETE',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to delete item category');
}
